export { delta as deltaFromArray } from './Delta'
export { areEquals as areArrayEquals } from './Equality'
export { isNotEmpty as isArrayNotEmpty, getLastElement as getNonEmptyArrayLastElement } from './Empty'
export { is as isArray, isOfType as isArrayOfType } from './Is'
export { createSorter as createArraySorter } from './Sort'
